<template>
    <div>
        <div class="mb-2">
            <b-button v-show="selected_audit > -1" class="me-3" variant="light" @click="handleBack()"><i class="fas fa-arrow-left"></i></b-button>
            <span v-show="selected_audit > -1" class="audit-title">{{selectedAuditName}}</span>
            <hr v-show="selected_audit > -1">
        </div>
        <div v-if="selected_audit == -1">
            <div v-show="audits.length == 0" style="text-align: center; font-size: 25px;">
                <span>Audits are coming soon!</span>
            </div>
            <div v-show="audits.length > 0">
                <webix-ui :config="config" v-model="audits"></webix-ui>
                <div id="auditsPaging"></div>
            </div>
        </div>
        <div v-else>
            <AuditSessions/>
        </div>
    </div>
</template>

<script>
import { facilityAdminState, facilityAdminMethods } from '@/state/helpers'
import AuditSessions from './sessions.vue'
export default {
    components:{
        AuditSessions
    },
    data:() => ({
        config:{
            id: 'suppliersTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            autoheight: true,
            //hover: "datatableHover",
            minHeight:50,
            scrollY:false,
            scrollX:true,
            resizeColumn: true,
            select: false,
            pager:{
                template:"{common.prev()} {common.pages()} {common.next()}",
                container:"auditsPaging",
                size:15,
                group:5
            },
            columns:[
                { id: 'actions', header:'Actions', width: 100,  template: function(obj){
                    if(!obj.active){
                        return '<div class="tableIcons"><i title="Purchase Audit" class="purchaseIcon iconHover webix_icon fas fa-shopping-cart"></i></div>'
                    }
                    else{
                        return '<div class="tableIcons"><i title="View Audit" class="viewAction iconHover  fas fa-clipboard-list"></i></div>';
                    }
                }},
                { id: 'name', template:"<span class='viewAction' style='cursor: pointer;'>#name#</span>", header:["Audit Name", {content: "textFilter"}], tooltip:false, fillspace: 1},
                { id: 'code',  header:["Code", {content: "textFilter"}], fillspace: 1},
                { id: 'revise_every', header: 'Revision Period', fillspace: 1},
            ],
            on:{

            },
            onClick:{
                purchaseIcon: function() {
                    this.$scope.$parent.$swal.fire({
                      title: "Please contact support to activate this audit for your account!",
                      //text: "You won't be able to revert this!",
                      icon: "warning",
                      showCancelButton: false,
                      confirmButtonColor: "#34c38f",
                      cancelButtonColor: "#f46a6a",
                      confirmButtonText: "Ok"
                    });
                    
                },//eslint-disable-next-line
                viewAction: function(id, e, trg) {
                    var el = this.$scope.$parent;
                    el.getClientAudit(e.row).then(()=>{
                        el.setSelectedAuditID(e.row)
                    });
                },
            },
        },
    }),
    computed:{
        ...facilityAdminState,
        audit_notifications(){
            return {
                available: 4,
                pending: 2,
                completed: 1,
            }
        },
        audits(){
            return this.all_audits;
        },
        selectedAuditName(){
            let audit = this.audits.find( audit => {
                return Number(this.selected_audit) == Number(audit.id);
            })
            return audit ? audit.name : '';
        }
    },
    methods:{
        ...facilityAdminMethods,
        handleBack(){
            if(this.selected_audit_session_id != -1){
                //just close the form and show selected audit sessions
                this.setSelectedSessionID(-1);
            }
            else{
                //clear selected audit and return to audits table
                this.setSelectedAuditID(-1);
            }
        }
    },
    mounted(){
        if(this.all_audits.length == 0){
            this.getAvailableAudits()
            .then(()=>{
                console.log(this.all_audits);
            })
        }
    },
}
</script>

<style>
.tableIcons {
    cursor: pointer;
    font-size: 1.5rem;
    text-align: center;
}
.iconHover:hover{
    color: var(--bs-danger);
    cursor: pointer;
}
.audit-title {
    font-size: 1.4rem;
}
</style>